import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import RenewalsPage from '@/pages/RenewalsPage';
import RenewalInsightsPage from '@/pages/RenewalInsightsPage';
import BrokerRenewalsPage from '@/pages/BrokerRenewalsPage';
import RenewalNudgesPage from '@/pages/RenewalNudgesPage';
import { useAuth } from '@/contexts/AuthContext';

export default function RenewalsModule() {
  const { user } = useAuth();
  const tabs = user?.role === 'broker'
    ? [{ id: 'pipeline', label: 'My Renewals', content: <BrokerRenewalsPage /> }]
    : [
    { id: 'pipeline', label: 'Pipeline', content: <RenewalsPage /> },
    { id: 'insights', label: 'Insights', content: <RenewalInsightsPage /> },
    { id: 'nudges', label: 'Nudges', content: <RenewalNudgesPage /> },
  ];

  return (
    <ModuleShell title="Renewals" subtitle="Retention and renewal workflow" tabs={tabs} />
  );
}
